// extracted by mini-css-extract-plugin
module.exports = {"collapse":"Collapse_collapse__3dj07","show":"Collapse_show__3eeMf"};